<template>
  <div class="wrapHorloge" v-if="clickOnBut < 2">
  <div v-if="clickOnBut == 1" class="start1"><button class="start" v-on:click="startOk()">Démarrer</button></div>
  <div :class="['base-timer', clickOnStart == 3 ? 'iclic' : '']" v-if="clickOnBut == 0">
    <svg class="base-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <g class="base-timer__circle">
        <circle class="base-timer__path-elapsed" cx="50" cy="50" r="45"></circle>
        <path
          :stroke-dasharray="circleDasharray"
          class="base-timer__path-remaining"
          :class="remainingPathColor"
          d="
            M 50, 50
            m -45, 0
            a 45,45 0 1,0 90,0
            a 45,45 0 1,0 -90,0
          "
        ></path>
      </g>
    </svg>
    <span :class="['base-timer__label', clickOnStart == 3 ? 'iLabClic' : '']" id="timer__label">{{ formattedTimeLeft }}</span>
    </div>
    <div class="gestionHorloge" v-if="clickOnBut == 0">
        <button v-if="stop == 'undefined' || stop == null" :class="[clickOnStop == true ? 'stopClic' : '', 'stop']" v-on:click="onTimesUp()">Arreter</button>
        <button class="start" @click.prevent="startRestart()" v-if="stop == 'undefined' || stop == null">Recommencer</button>
        <button class="start" v-on:click="startTimer()"  :class="[clickOnStart == 3 ? 'clicStart' : '']" v-else>Démarrer</button>
    </div>
  </div>
</template>

<script>
const FULL_DASH_ARRAY = 283;
const WARNING_THRESHOLD = 20;
const ALERT_THRESHOLD = 10;

const COLOR_CODES = {
  info: {
    color: "green"
  },
  warning: {
    color: "green",
    threshold: WARNING_THRESHOLD
  },
  alert: {
    color: "green",
    threshold: ALERT_THRESHOLD
  }
};

const TIME_LIMIT = 15;

export default {
  props: {

    stop: {
      type: [String, Number],
      default: null
      },

    timeLimit: {
      type: [String, Number],
      default: TIME_LIMIT
      },
  },
  data() {
    return {
      timePassed: 0,
      timerInterval: null,
      clickOnStart: 0,
      clickOnStop: false, 
      clickOnBut:0,
    };
  },
  created(){
    if (this.stop  == 'undefined' || this.stop == null){
      this.clickOnBut = 1; 
    }
  },
  computed: {
    circleDasharray() {
      return `${(this.timeFraction * FULL_DASH_ARRAY).toFixed(0)} 283`;
    },

    formattedTimeLeft() {
      const timeLeft = this.timeLeft;
      const minutes = Math.floor(timeLeft / 60);
      
      let seconds = timeLeft % 60;

      

      if (seconds < 10) {
        seconds = `0${seconds}`;
      }

      if(this.timeLimit >= 60){
        return `${minutes}:${seconds}`;
      }else{
        return `${seconds}`;
      }
    },

    timeLeft() {
      return this.timeLimit - this.timePassed;
    },

    timeFraction() {
      const rawTimeFraction = this.timeLeft / this.timeLimit;
      return rawTimeFraction - (1 / this.timeLimit) * (1 - rawTimeFraction);
    },

    remainingPathColor() {
      const { alert, warning, info } = COLOR_CODES;

      if (this.timeLeft <= alert.threshold) {
        return alert.color;
      } else if (this.timeLeft <= warning.threshold) {
        return warning.color;
      } else {
        return info.color;
      }
    }
  },

  watch: {
    timeLeft(newValue) {
      if (newValue === 0) {
        this.onTimesUp();
      }
    }
  },
    /*
  mounted() {
    this.startTimer();
  },*/

  methods: {
    onTimesUp(restart=null) {
        clearInterval(this.timerInterval);
        this.clickOnStop = true;
        if(restart==null){
          let equi =document.getElementById('timer__label').innerHTML;
          let tab =  equi.split(":");
          let nb = Number(tab[1])
          localStorage.resultatTest1 = nb;
          this.$emit('stopClic');
          this.clickOnBut = 2;
        }
        
    },

    startTimer() {
      console.log('ok')
      this.$emit('clickOnStart');
      if (this.clickOnStart < 2){
        if (this.stop == 1){
            this.timerInterval = setInterval(() => (this.timePassed += 1), 1000);
            this.clickOnStart = 3;
        }else{
            this.timePassed = 0;
            this.timerInterval = setInterval(() => (this.timePassed += 1), 1000);
            this.clickOnStart++;
        }
      }   
    },
    startOk(){
      this.clickOnBut = 0;
      this.startTimer();
    },
    startRestart(){
      console.log('ok');
      this.onTimesUp(true);
      this.startTimer();
    }
  }
};
</script>

<style scoped lang="css">
 .base-timer__path-remaining.green {
   /*color: #41b883;*/
   color: #54c7da;
}
 .base-timer__path-remaining.orange {
   /*color: orange;*/
   color: #473334;
}
 .base-timer__path-remaining.red {
   color: #c41316;
}
.start1{
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 25%;
}
.clicStart{
    position: relative !important;
    visibility: hidden;
    opacity: 0 !important;
    transform: translateY(+30px) !important;
    transition: visibility 1s, opacity 1s, transform 1s linear !important;
}
.iclic{
    position: relative !important;
    transform: translate(50%, 15%) !important;
    width: 35%;
    max-width: 250px;
    transition: width 1s, height 1s, transform 1s linear !important;
}
.iLabClic{
    position: relative !important;
    bottom: 85%;
    width: 150px;
    height: 150px;
    transition: width 1s, height 1s bottom 1s linear !important;
}
@media screen and (max-width: 479px) {
.iclic{
    position: relative !important;
    transform: translateY(+15px) !important;
    width: 140px;
    height: 140px;
    transition: width 1s, height 1s, transform 1s linear !important;
}

.iLabClic{
    position: relative !important;
    bottom: 88px;
    width: 150px;
    height: 150px;
    transition: width 1s, height 1s bottom 1s linear !important;
}
}
</style>



// WEBPACK FOOTER //
// src/components/BaseTimer.vue